import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/business-settings")({
  component: lazyRouteComponent(() => import("./-pages/admin.business-settings")),
  head: () => ({ meta: [{ title: "Lecmo · إعدادات تجاريّة" }] }),
});
